export default "__VITE_ASSET__DknNIObU__"